import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHouse1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke='#fff'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8'
      opacity={0.6}
    />
    <path
      stroke='#fff'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M10 19v-5a2 2 0 1 1 4 0v5'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m2 10 10-6 10 6'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHouse1)
export default ForwardRef
